module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1#ch1"
    }
  }, [_vm._v("1: MATERIALS & TOOLS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1#lev1"
    }
  }, [_vm._v("SOAP FOR CARVING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1#lev2"
    }
  }, [_vm._v("Tools for Carving Soap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1#lev3"
    }
  }, [_vm._v("Additional Carving Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1#lev4"
    }
  }, [_vm._v("Other Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2: ESSENTIAL TECHNIQUES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GETTING STARTED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing to Carve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Softening Soap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holding a Carving Knife Correctly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working with the Templates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shaping Soap for Carving")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CARVING LESSONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#les1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Lesson 1")])]), _vm._v(" V-Shaped Grooves and Incisions—Leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#les2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Lesson 2")])]), _vm._v(" Triangular Patterns—Simple Bird")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#les3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Lesson 3")])]), _vm._v(" Circular Scalloped Patterns—Scalloped Butterfly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#les4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Lesson 4")])]), _vm._v(" Delicate Waves—Purse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#les5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Lesson 5")])]), _vm._v(" Complex Floral Designs—Dahlia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#les6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Lesson 6")])]), _vm._v(" Complex Floral Designs—Rose Relief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#les7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Lesson 7")])]), _vm._v(" Complex Floral Designs—Rose: Starting with the Outer Petals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#les8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Lesson 8")])]), _vm._v(" Complex Floral Designs—Rose: Starting at the Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADDING COLOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DECORATING WITH BEADS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RECYCLING SOAP SCRAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream Soap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recycling Soap Scraps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soap Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GIFT-GIVING IDEAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: CARVING PROJECTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EASY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro1a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 1")])]), _vm._v(" Mini Cactus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 2")])]), _vm._v(" Lily of the Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 3")])]), _vm._v(" Dachshund")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 4")])]), _vm._v(" Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 5")])]), _vm._v(" Squirrel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 6")])]), _vm._v(" Sheep")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 7")])]), _vm._v(" Sea Turtle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 8")])]), _vm._v(" Little Insects: Ladybug, Bee & Snail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 9")])]), _vm._v(" Miniature Cake Slice & Doughnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 10")])]), _vm._v(" Miniature Cream Puff Swan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTERMEDIATE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro11a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 11")])]), _vm._v(" Scalloped Frame")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 12")])]), _vm._v(" High-Top Sneakers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 13")])]), _vm._v(" Party Dress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 14")])]), _vm._v(" Umbrella")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 15")])]), _vm._v(" Teacup & Saucer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 16")])]), _vm._v(" Bouquet of Miniature Lilies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 17")])]), _vm._v(" Starry Cutwork Soap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 18")])]), _vm._v(" Heart Lamp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 19")])]), _vm._v(" Orchid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 20")])]), _vm._v(" Carnation Arrangement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADVANCED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro21a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 21")])]), _vm._v(" Unicorn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 22")])]), _vm._v(" Lock & Key")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 23")])]), _vm._v(" Heart Clock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 24")])]), _vm._v(" Gardenia with Curled Petals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3h1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#pro25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('strong', [_vm._v("Project 25")])]), _vm._v(" Mermaid")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/temp#temp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEMPLATES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author#author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0